




























import Vue from 'vue'
import { TimePickerInterface } from '@/config/interfaces'
import { eachHourOfInterval, format, Interval } from 'date-fns'

export default Vue.extend({
  name: 'TimePickerEl',

  mounted () {
    this.selected = this.templateItemData.value ?? ''
  },

  data: () => ({
    selected: ''
  }),

  props: {
    templateItemData: {
      type: Object as () => TimePickerInterface,
      required: true
    }
  },
  computed: {
    timeIntervalArray (): Array<string> {
      const minHour = parseInt(this.templateItemData.minTime ? (this.templateItemData.minTime).substring(0, 3) : '00')
      const minMinutes = parseInt(this.templateItemData.minTime ? (this.templateItemData.minTime).substring(3, 5) : '00')
      const maxHour = parseInt(this.templateItemData.maxTime ? (this.templateItemData.maxTime).substring(0, 2) : '23')
      const startDate = new Date().setHours(minHour, minMinutes)
      const endDate = new Date().setHours(maxHour)
      const interval: Interval = { start: startDate, end: endDate }
      const intervalHours = eachHourOfInterval(interval)
      return intervalHours.map(value => format(value, 'HH:mm'))
    }
  }
})
